const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/persons/$id.tourrep.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */

import { getFindPersonJobsListQueryOptions } from '@api';
import { createTableQuerySchema, getTableParams } from '@common';
import { hasOneOfPermissions } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
const TABLE_IDS = ['upcomingShows', 'previousShows'] as const;
const searchSchema = createTableQuerySchema({
  tableIds: TABLE_IDS
});
export const Route = createFileRoute('/_rootLayout/persons/$id/tourrep')({
  validateSearch: search => searchSchema.parse(search),
  loaderDeps: ({
    search
  }) => ({
    upcoming: getTableParams(search, 'upcomingShows'),
    previous: getTableParams(search, 'previousShows')
  }),
  beforeLoad: async ({
    context: {
      permissions
    },
    params: {
      id
    }
  }) => {
    const hasValidPermission = hasOneOfPermissions(permissions, [{
      permission: 'ADDRESSBOOK_TOURREP_SCHEDULE',
      action: 'READ'
    }, {
      permission: 'PROJECTS_TOURREP_CALENDAR',
      action: 'WRITE'
    }]);
    if (!hasValidPermission) {
      throw redirect({
        to: '/persons/$id',
        params: {
          id: id
        },
        replace: true,
        throw: true
      });
    }
  },
  loader: async ({
    context: {
      queryClient
    },
    params: {
      id
    },
    deps: {
      upcoming,
      previous
    }
  }) => {
    queryClient.ensureQueryData(getFindPersonJobsListQueryOptions(id, {
      type: 'UPCOMING',
      ...upcoming
    }));
    queryClient.ensureQueryData(getFindPersonJobsListQueryOptions(id, {
      type: 'PREVIOUS',
      ...previous
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});